import { useCallback, useEffect } from 'react';

import { Stack, Typography } from '@mui/material';

import type { NotificationSubscriptionResultPayload } from '@system/app';
import { NotificationEvents, useApp } from '@system/app';

export function useNews() {
  const { notification, flags, toast } = useApp();

  const maintenance_mode = flags?.find(
    item => item.name === 'maintenance_mode',
  );

  const isMaintenanceMode = maintenance_mode?.value === 'on';

  const messageInfoNews = useCallback(
    (payload: NotificationSubscriptionResultPayload) => {
      toast.info(
        <Stack>
          <Typography>Новое сообщение в разделе "Новости":</Typography>
          <Typography>{payload.data.message}</Typography>
        </Stack>,
      );
    },
    [toast],
  );

  useEffect(() => {
    if (!isMaintenanceMode) {
      const handlerLink = notification.subscribe(
        NotificationEvents.messageInfoNews,
        messageInfoNews,
      );
      return () => {
        notification.unsubscribe(
          NotificationEvents.messageInfoNews,
          handlerLink,
        );
      };
    }
  }, [isMaintenanceMode, notification, messageInfoNews]);

  return null;
}
